module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vnerv5-e4e4a76e8c7bac0ae319f9d3008828aa.jpg";